import React from 'react';
import { CtaButton } from './CtaButton';
import { SectionHeading } from './SectionHeading';
import { extraTools } from '../data/extraTools';
export function ExtraToolsSection() {
  return <section className="w-full bg-white px-5 py-16 sm:py-20" data-id="element-87" data-mp="67458iyw6a1q">
      <div className="mx-auto max-w-3xl" data-id="element-88" data-mp="69gulh6zbmot">
        <SectionHeading title={<>
              And you'll also get <span className="text-electric-600" data-id="element-90" data-mp="3sekiszuzoy2m">immediate access to:</span>
            </>} data-id="element-89" data-mp="18st21l4jngc" />
        <ul className="mt-10 divide-y divide-slate-200" data-id="element-91" data-mp="3nnc69uyd4wl8">
          {extraTools.map(({
          icon: Icon,
          title,
          text
        }) => <li key={title} className="flex gap-4 py-5" data-id="element-92" data-mp="3jnbtsfutqvgt">
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-electric-500" data-id="element-93" data-mp="3en5x2l9p6irv">
                <Icon className="h-6 w-6 text-white" aria-hidden="true" data-id="element-94" data-mp="39nta80ittbpa" />
              </span>
              <div data-id="element-95" data-mp="34p9n3wshxtvc">
                <h3 className="font-display text-[24px] font-extrabold uppercase leading-tight text-ink" data-id="element-96" data-mp="34oq38ajacveo">{title}</h3>
                <p className="mt-1 text-[15px] leading-relaxed text-muted" data-id="element-97" data-mp="3gc9vbukz4h3k">{text}</p>
              </div>
            </li>)}
        </ul>
        <p className="mx-auto mt-8 max-w-2xl text-center text-[17px] leading-relaxed text-muted" data-id="element-98" data-mp="3l5l80ccgvs3e">
          Every unfamiliar TCM presents its own challenges. With TCM Diagnostic Blueprint™, you'll have a structured
          way to organize the information, evaluate the situation, and{' '}
          <strong className="text-ink" data-id="element-99" data-mp="2w2kt1lvlw7h">determine what to investigate next.</strong>
        </p>
        <CtaButton label="I want the complete TCM system" className="mt-10" data-id="element-100" data-mp="7v5mcc2ndkap" />
      </div>
    </section>;
}